import React, { useEffect } from "react";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";

function PlaatsWerkplan() {
  useEffect(() => {
    $("#plaats_in_werkplan").on("show.bs.modal", function (event) {
      let contentModel = {
        key: "algemeen-compleet",
        and_or: "AND",
        values: [true],
        datatype: "BOOLEAN",
      };

      GC.GetEntityList(
        process.env.REACT_APP_CATALOG_WORK_PLANS,
        1,
        30,
        CallBackFunctions.PlaatsWerkplanCallback,
        window.$mm_management_units_token
      );
    });
  });

  const handleSubmit = () => {
    $("#cover-spin").show(0);
    var budgetId = $("input[name=plaats-werkplan]:checked").attr("id");
    var element = $("input[name=plaats-werkplan]:checked");
    var label = $(element).next("label").attr("for", budgetId);
    var model = { werkplan: budgetId };
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    GC.StartActivity(
      model,
      selectedIds,
      "1041f11d-46f4-4a46-a1c5-8e6d91f0877f",
      submitCallBack,
      window.$mm_management_units_token
    );
  };

  function submitCallBack() {
    GC.sleep(500).then(() => {
      $("#plaats_in_werkplan").modal("hide");
      window.$mm_work_plans_refresh();
      /*omnimap
        .FillTableAction(
          window.$mm_work_plans_lastUsedTableFilter,
          1,
          window.$mm_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  }
  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="plaats_in_werkplan"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Toevoegen aan werkplan</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input
              type="search"
              className="modal-search"
              placeholder="Zoeken naar werkplannen"
            />
            <div className="modal-scroll">
              <div id="plaats-werkplan-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_plaats_werkplan"
              className="btn-modal"
              onClick={handleSubmit}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlaatsWerkplan;
